import { createApp } from "vue";

import App from "./App.vue";
import router from "./router/router";
import store from "./store/index.js";
// import VueApexCharts from "vue3-apexcharts";
import VCalendar from "v-calendar";
import Vapor from "laravel-vapor";

import "./index.css";
import "flowbite";
import "v-calendar/dist/style.css";
import vSelect from 'vue-select';


// import the package
import VueAwesomePaginate from "vue-awesome-paginate";

// import the necessary css file
import "vue-awesome-paginate/dist/style.css";
import 'vue-select/dist/vue-select.css';
// window.addEventListener("onbeforeunload", () => localStorage.clear());

let isRefreshing = false;
window.addEventListener('beforeunload', function(event) {
    isRefreshing = true;
  });
window.addEventListener('beforeunload', function(event) {
    if (!isRefreshing) {
        localStorage.clear();
      }
  });

  
import mixpanel from "mixpanel-browser";
// or with require() syntax:
// const mixpanel = require('mixpanel-browser');

// Enabling the debug mode flag is useful during implementation,
// but it's recommended you remove it for production
mixpanel.init("be847f39a3d2bc716c2aaa3e5f4be0cc", { debug: true });
mixpanel.track("Sign up");
createApp(App)
    .use(router)
    .use(store)
    .use(VCalendar, {})
    .use(VueAwesomePaginate)
    .use(Vapor)
    .component('v-select', vSelect)
    .mount("#app");
